/**
 * External dependencies
 */
import {
	SvgIcon, SvgIconPlaceholder, UrlInputPopover, IconDisplay
} from '~cartzillagb/components'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { Component, Fragment } from '@wordpress/element'
import classnames from 'classnames'
import { i18n } from 'cartzillagb'
import { RichText } from '@wordpress/block-editor'

// Deprecated ButtonEdit.Content methods.
export * from './deprecated'
export { default as ButtonEditHelper } from './helper'

// TODO: [V2] move ButtonEdit to RichButton

let buttonInstanceId = 1

class ButtonEdit extends Component {
	constructor() {
		super( ...arguments )
		this.state = {
			openPopup: false,
		}
		this.buttonInstanceId = buttonInstanceId++

		this.onButtonClickHandler = this.onButtonClickHandler.bind( this )
		this.outsideClickHandler = this.outsideClickHandler.bind( this )
		this.onKeyPressHandler = this.onKeyPressHandler.bind( this )
	}

	onButtonClickHandler( event ) {
		if ( this.props.buttonIcon && event.target.closest( '.czgb-svg-icon-placeholder__button' ) ) {
			// If this is an icon button, open the url popover if the icon is clicked.
		} else if ( event.target.closest( '.czgb-svg-icon-placeholder__button' ) ||
			event.target.closest( '.czgb-url-input-popover' ) ||
			event.target.closest( '.czgb-icon-popover' ) ||
			event.target.closest( '.components-popover' )
		) {
			return
		}
		if ( ! this.state.openPopup ) {
			document.body.addEventListener( 'click', this.outsideClickHandler )
		}
		this.setState( { openPopup: true } )
	}

	outsideClickHandler( event ) {
		if ( ! event.target.closest( `.czgb-button-container-${ this.buttonInstanceId }` ) &&
			! event.target.closest( '.czgb-url-input-popover' ) &&
			! event.target.closest( '.components-popover' ) ) {
			this.hideUrlPopup()
		} else if ( this.props.buttonIcon && event.target.closest( '.czgb-svg-icon-placeholder__button' ) ) {
			// If this is an icon button, don't close the url popover if the icon is clicked.
		} else if ( event.target.closest( '.czgb-svg-icon-placeholder__button' ) ) {
			this.hideUrlPopup()
		}
	}

	hideUrlPopup = () => {
		document.body.removeEventListener( 'click', this.outsideClickHandler )
		this.setState( { openPopup: false } )
	}

	onKeyPressHandler( event ) {
		if ( event.target.closest( '.czgb-url-input-popover' ) ||
			event.target.closest( '.components-popover' ) ) {
			return
		}
		this.hideUrlPopup()
	}

	render() {
		const {
			newTab = '',
			noFollow = '',
			onChangeNewTab = null,
			onChangeNoFollow = null,
			size = 'default',
			animation = 'none',
			delay = 'none',
			shape = 'default',
			backgroundColor = 'primary',
			text = '',
			onChange = () => {},
			design = 'solid',
			shadow = 0,
			iconAfterText = 0,
			buttonIcon = 0,
			url = '',
			target = '',
			onChangeUrl = null,
			onChangeIcon = null,
			icon = null,
			isSelected = null,
		} = this.props

		const mainClasses = classnames( [
			'btn',
			'mr-1',
		], {
			[ `btn-${ shape }` ] : shape,
			[ `btn-${ size }` ] : size,
			[ `${ animation }` ] : animation,
			[ `${ delay }` ] : delay,
			'btn-shadow' : shadow === true,
			'mb-2' : size !== 'sm',
			[`btn-${ backgroundColor }`]: design === 'solid',
			[`btn-${ design }-${ backgroundColor }`]: design !== 'solid',
			'button-icon': icon,
			'czgb-button--has-icon' : buttonIcon === true,
		} )

		const openUrlPopover = ( isSelected !== null ? isSelected : true ) && this.state.openPopup

		const iconadditionalClass = ( iconAfterText === true ? 'ml-2 mr-n1' : 'mr-2 ml-n1' )

		const iconComp = ( 
			<IconDisplay 
				value={ icon }
				additionalClass={ iconadditionalClass }
			/>
		)

		return (
			<div
				onClick={ this.onButtonClickHandler }
				onKeyPress={ this.onKeyPressHandler }
				role="button"
				tabIndex="0"
			>
				<a 
					href="javascript:;"
					className={ mainClasses }
					data-scroll
				>
					{ icon && ! iconAfterText && iconComp }
					{ ! buttonIcon &&
						<RichText
							tagName="span"
							className={ `czgb-button--inner` }
							placeholder={ __( '', i18n ) }
							value={ text }
							onChange={ onChange }
							withoutInteractiveFormatting={ true }
							keepPlaceholderOnFocus
						/>
					}
					{ icon && iconAfterText && iconComp }
					{ openUrlPopover &&
						<UrlInputPopover
							value={ url }
							onChange={ onChangeUrl }
							disableSuggestions={ this.props.disableSuggestions }
						/>
					}
				</a>
			</div>
		)
	}
}

ButtonEdit.defaultProps = {
	disableSuggestions: false,
	className: '',
	size: 'default',
	animation: 'none',
	delay: 'none',
	url: '',
	icon: null,
	text: '',
	design: 'solid',
	shape: 'default',
	backgroundColor: 'primary',
	shadow: 0,
	iconAfterText: 0,
	buttonIcon: 0,
	newTab: '',
	noFollow: '',
	onChange: () => {},

	onChangeUrl: null,
	onChangeIcon: null,
	isSelected: null,
	onChangeNewTab: null,
	onChangeNoFollow: null,
}

ButtonEdit.Content = props => {
	const {
		className = '',
		size = 'default',
		animation = 'none',
		delay = 'none',
		url = '',
		newTab = '',
		noFollow = '',
		icon = null,
		text = '',
		target = '',
		design = 'solid',
		shape = 'default',
		backgroundColor = 'primary',
		shadow = 0,
		iconAfterText = 0,
		buttonIcon = 0,
	} = props

	const mainClasses = classnames( [
		'btn',
		'mr-1',
	], {
		[ `btn-${ shape }` ] : shape,
		[ `btn-${ size }` ] : size,
		[ `${ animation }` ] : animation,
		[ `${ delay }` ] : delay,
		'btn-shadow' : shadow === true,
		'mb-2' : size !== 'sm',
		[`btn-${ backgroundColor }`]: design === 'solid',
		[`btn-${ design }-${ backgroundColor }`]: design !== 'solid',
		'button-icon': icon,
		'czgb-button--has-icon' : buttonIcon === true,

	} )

	const iconadditionalClass = ( iconAfterText === true ? 'ml-2 mr-n1' : 'mr-2 ml-n1' )

	const iconComp = ( 
		<IconDisplay 
			value={ icon }
			additionalClass={ iconadditionalClass }
		/>
	)

	return (
		<a
			href={ url }
			className={ mainClasses }
			data-scroll
		>
			{ icon && ! iconAfterText && iconComp }
			{ ! buttonIcon &&
				<RichText.Content
					tagName="span"
					className={ `czgb-button--inner` }
					value={ text }
				/>
			}
			{ icon && iconAfterText && iconComp }
		</a>
	)

}

export default ButtonEdit
